import About from "../components/sections/About";
import SideList from "../components/sections/SideList";
import Title from "../components/sections/Title";
import UsefulFor from "../components/sections/UsefulFor";
import WideContainer from "../components/WideContainer";
import CenteredRow from "../components/CenteredRow";
import { about, during, technique, usefulFor } from "../content/Indian";

const color = "head-massage";

function Indian(){
    return (
        <main className="flex-grow-1">
            <Title title="Indiai&nbsp;fejmasszázs" color={color}/>
            <About title="Indiai fejmasszázs" paragraphs={about} color={color}/>
            <SideList
                id="during"
                title="Kezelés alatt"
                secondaryText="(15-30 perc)"
                listItems={during}
                alignRight={true}
                color={color}
            />
            <UsefulFor listItems={usefulFor} color={color} />
           
            <WideContainer id="head-massage">
                <CenteredRow>
                    <p className="mb-2">
                        {technique}
                    </p>
                </CenteredRow>
            </WideContainer>
        </main>
    );
}

export default Indian;